import {
  type DateOfBirthFieldStrings,
  strings as defaultStrings,
} from './DateOfBirthField.strings'
import { Space } from '../Space'
import { TextField } from '../TextField'

export enum DateOfBirthFieldOrder {
  DAY_MONTH_YEAR = 'DAY_MONTH_YEAR',
  MONTH_DAY_YEAR = 'MONTH_DAY_YEAR',
}

export interface DateOfBirthFieldProps {
  strings: Partial<DateOfBirthFieldStrings>
  value?: DateOfBirth
  onChange?: (dateOfBirth: DateOfBirth) => void
  onBlur?: () => void
  dateFormat: DateOfBirthFieldOrder
  required?: boolean
  error?: boolean
  disabled?: boolean
}

export interface DateOfBirth {
  day: string
  month: string
  year: string
}

export const DateOfBirthField = ({
  strings,
  dateFormat = DateOfBirthFieldOrder.MONTH_DAY_YEAR,
  required = false,
  onChange,
  value,
  onBlur,
  error,
  disabled,
}: DateOfBirthFieldProps) => {
  strings = {
    ...defaultStrings,
    ...strings,
  }

  const handleChange = (field: keyof DateOfBirth) => (e) => {
    onChange({
      ...value,
      [field]: e.target.value,
    })
  }

  const renderDayField = () => (
    <Space.Item width={1 / 4}>
      <TextField
        id='day'
        name='day'
        label={strings.dayLabel}
        placeholder={strings.dayPlaceholder}
        onChange={handleChange('day')}
        inputProps={{
          maxLength: 2,
        }}
        required={required}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
        value={value?.day || ''}
      />
    </Space.Item>
  )

  const renderMonthField = () => (
    <Space.Item width={1 / 4}>
      <TextField
        id='month'
        name='month'
        label={strings.monthLabel}
        placeholder={strings.monthPlaceholder}
        onChange={handleChange('month')}
        inputProps={{
          maxLength: 2,
        }}
        required={required}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
        value={value?.month || ''}
      />
    </Space.Item>
  )

  const renderYearField = () => (
    <Space.Item width={1 / 2}>
      <TextField
        id='year'
        name='year'
        label={strings.yearLabel}
        placeholder={strings.yearPlaceholder}
        onChange={handleChange('year')}
        inputProps={{
          maxLength: 4,
        }}
        required={required}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
        value={value?.year || ''}
        fullWidth
      />
    </Space.Item>
  )

  return dateFormat === DateOfBirthFieldOrder.MONTH_DAY_YEAR ? (
    <Space direction='horizontal' size='medium'>
      {renderMonthField()}
      {renderDayField()}
      {renderYearField()}
    </Space>
  ) : (
    <Space direction='horizontal' size='medium'>
      {renderDayField()}
      {renderMonthField()}
      {renderYearField()}
    </Space>
  )
}

DateOfBirthField.displayName = 'DateOfBirthField'
